import flatten from './flatten';

const preload = (resources) => flatten(resources.filter(Boolean).map(
  (resource) => [{ rel: 'preconnect', href: resource },
    { rel: 'dns-prefetch', href: resource }]
));
export default preload;
